__turbopack_context__.v({
  "l26": "Loader-module-scss-module__gsNpFG__l26",
  "loader": "Loader-module-scss-module__gsNpFG__loader",
  "loader-box-bounce": "Loader-module-scss-module__gsNpFG__loader-box-bounce",
  "loader__sq": "Loader-module-scss-module__gsNpFG__loader__sq",
  "loader_main": "Loader-module-scss-module__gsNpFG__loader_main",
  "loading-text": "Loader-module-scss-module__gsNpFG__loading-text",
  "loading_text": "Loader-module-scss-module__gsNpFG__loading_text",
  "new_loader_main": "Loader-module-scss-module__gsNpFG__new_loader_main",
  "new_loader_small_main": "Loader-module-scss-module__gsNpFG__new_loader_small_main",
  "newloader": "Loader-module-scss-module__gsNpFG__newloader",
});
